import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Portal } from 'react-portal';
import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

import {
  formatPrice,
} from 'common/formatters';

import {
  DATA_TABLE_SOURCE_DEPOSITS,
  DATA_TABLE_VIEW_ID_DEPOSITS,
} from 'common/dataTableConstants';
import preventDefaultPropagation from 'client/helpers/preventDefaultPropagation';
import {
  dataTable,
  actionDataTableLoadNextPage,
  actionDataTableLoadItems,
} from 'client/helpers/dataTables';
import withInfiniteScroll from 'client/helpers/withInfiniteScroll';

import SrTable from 'client/components/SrTable';
import SrCreateDepositForm from 'client/components/financeAdmin/SrCreateDepositForm';

@dataTable({
  dataSource: DATA_TABLE_SOURCE_DEPOSITS,
  viewId: DATA_TABLE_VIEW_ID_DEPOSITS,
  sort: {
    'paymentsReceived.createdDate': 'desc',
  },
})
@withInfiniteScroll({
  offset: 32,
})
class SrDataTableDeposits extends Component {
  static propTypes = {
    items: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
    dataTableApiState: PropTypes.object.isRequired,
    dataTableIsFullyLoaded: PropTypes.bool.isRequired,
    onInfiniteScrollWrapperRef: PropTypes.func.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      showCreateDepositModal: false,
    };

    const { onInfiniteScrollCallbackReady } = props;
    onInfiniteScrollCallbackReady(this._infiniteScrollCallback);
  }

  _infiniteScrollCallback = () => {
    const { dataTableIsFullyLoaded, dispatch } = this.props;
    if (!dataTableIsFullyLoaded) {
      dispatch(actionDataTableLoadNextPage, {
        dataSource: DATA_TABLE_SOURCE_DEPOSITS,
        viewId: DATA_TABLE_VIEW_ID_DEPOSITS,
        count: 8,
      });
    }
  }

  _onReloadItemRequested = (itemId) => {
    const { dispatch } = this.props;
    dispatch(actionDataTableLoadItems, {
      dataSource: DATA_TABLE_SOURCE_DEPOSITS,
      viewId: DATA_TABLE_VIEW_ID_DEPOSITS,
      filter: {
        'invoicePayments.id': itemId,
      },
      count: 1,
    });
  }

  _toggleCreateDepositModal = () => {
    this.setState({ showCreateDepositModal: !this.state.showCreateDepositModal });
  }

  render() {
    const {
      showCreateDepositModal,
    } = this.state;

    const {
      items,
      dataTableApiState,
      onInfiniteScrollWrapperRef,
    } = this.props;

    return (
      <div className='SrDataTableDeposits'>
        <button
          type='button'
          onClick={this._onRefreshButtonClick}
          className='floatButton refresh'
        />
        <button
          type='button'
          onClick={this._toggleCreateDepositModal}
          className='floatButton add'
        />
        <div ref={onInfiniteScrollWrapperRef}>
          {dataTableApiState.error && (
            <span>ERROR: { dataTableApiState.error }</span>
          )}
          <div className='adminTableTopActionsContainer'>
            <button
              type='button'
              className='button blue'
              onClick={this._toggleCreateDepositModal}
            >
              register new deposit
            </button>
          </div>
          <SrTable
            headers={[
              { content: 'invoice payment id' },
              { content: 'check id' },
              { content: 'check number' },
              { content: 'invoice id' },
              { content: 'amount' },
              { content: 'created' },
              { content: 'check status' },
              { content: 'renter name' },
              { content: 'renter phone' },
              { content: 'locator name' },
              { content: 'email for invoice' },
              { content: 'apartment name' },
              { content: 'address' },
              { content: 'type' },
            ]}
            rows={items.map((invoicePayment) => ({
              cells: [
                { content: invoicePayment.id },
                { content: invoicePayment.paymentReceivedId },
                { content: invoicePayment.checkNumber },
                { content: invoicePayment.invoiceId },
                { content: formatPrice(invoicePayment.amount) },
                { content: momentWithAustinTimezone(invoicePayment.createdDate).format('MMM Do, YYYY - LTS') }, // eslint-disable-line max-len
                { content: invoicePayment.paymentReceivedStatus },
                { content: invoicePayment.renterName },
                { content: invoicePayment.renterPhone },
                { content: invoicePayment.locatorName },
                { content: invoicePayment.invoiceEmailRecipient },
                { content: invoicePayment.apartmentName },
                { content: invoicePayment.addressStreetDisplay },
                { content: invoicePayment.paymentReceivedType },
              ],
            }))}
          />
          {dataTableApiState.inProgress && (
            <div className='loading-ellipses left' />
          )}
        </div>

        {showCreateDepositModal && (
          <Portal>
            <div className='adminModal'>
              <div className='backdrop' onClick={this._toggleCreateDepositModal}>
                <div onClick={preventDefaultPropagation}>
                  <SrCreateDepositForm
                    onDepositCreated={(paymentReceived) => {
                      this._onReloadItemRequested(paymentReceived.id);
                      this._toggleCreateDepositModal();
                    }}
                  />
                </div>
              </div>
            </div>
          </Portal>
        )}
      </div>
    );
  }
}

SrDataTableDeposits.displayName = 'SrDataTableDeposits';

export default SrDataTableDeposits;
